export default __webpack_public_path__ + "static/media/img9.2d1eb67f.png";